import script from "./edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit.vue?vue&type=script&setup=true&lang=ts"

import "./edit.vue?vue&type=style&index=0&id=27808395&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27808395"]])

export default __exports__